var styles = {"fontElementMap":"_0uWzZ","orderedlist":"lpVAq","bulletedlist":"f3A66","listItem":"_5wstN"};

export { styles as s };
//# sourceMappingURL=lists-d936b7a0.js.map
